import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateSpecialNumber } from 'API/SpecialNumbers/updateSpecialNumber';

const useUpdateSpecialNumber = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const update = async (specialNumberData) => {
        const response = await updateSpecialNumber(specialNumberData);
        return response.data;
    };

    return useMutation({
        mutationFn: update,
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({ queryKey: ['SpecialNumbers'] });
            queryClient.invalidateQueries({
                queryKey: ['SpecialNumber', variables.id],
            });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useUpdateSpecialNumber;
